import { defineStore } from 'pinia'

interface StatisticsStoreOption {
  id: number
  name: string
}

const fillStoreNames = (value: unknown, storeNameMap: Map<string, string>) => {
  if (Array.isArray(value)) {
    value.forEach(item => fillStoreNames(item, storeNameMap))
    return
  }
  if (!value || typeof value !== 'object') return

  const record = value as Record<string, unknown>
  if (record.deptId !== undefined && record.deptId !== null) {
    const storeName = storeNameMap.get(String(record.deptId))
    if (storeName) record.deptName = storeName
  }
  Object.values(record).forEach(item => fillStoreNames(item, storeNameMap))
}

/**
 * 统计页面的临时门店范围，不持久化，离开统计模块后立即失效。
 */
export const useStatisticsStore = defineStore('statistics-scope', {
  state: () => ({
    active: false,
    selectedDeptId: null as number | null,
    storeOptions: [] as StatisticsStoreOption[],
    storeOptionsReady: false,
  }),
  actions: {
    enter() {
      this.active = true
      this.selectedDeptId = null
    },
    leave() {
      this.active = false
      this.selectedDeptId = null
    },
    selectDept(deptId: number | null) {
      this.selectedDeptId = deptId
    },
    setStoreOptions(options: StatisticsStoreOption[]) {
      this.storeOptions = options
      this.storeOptionsReady = true
    },
    markStoreOptionsReady() {
      this.storeOptionsReady = true
    },
    getStoreName(deptId: number | string | null | undefined) {
      if (deptId === undefined || deptId === null) return ''
      return (
        this.storeOptions.find(item => String(item.id) === String(deptId))
          ?.name ?? ''
      )
    },
    fillStoreNames(value: unknown) {
      const storeNameMap = new Map(
        this.storeOptions.map(item => [String(item.id), item.name])
      )
      fillStoreNames(value, storeNameMap)
    },
  },
})
